import type { CourseInfoTranslate } from "@/lib/course/utils/getCourseInformation";

function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function getNextCourseOneLineText(
  startText: string,
  t: CourseInfoTranslate,
): string {
  const startsLabel = t("starts");
  const normalized = startText.replace(
    new RegExp(`^${escapeRegExp(startsLabel)}`, "i"),
    startsLabel.toLocaleLowerCase(),
  );
  return t("nextCourseLine", { startText: normalized });
}

export default getNextCourseOneLineText;
